import { BaseRouteService } from 'core/services';

class ExportToCSVRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'export-to-csv/';
	}

	getOrdersForExport(filter) {
		return super.create(this.base + 'get-orders-for-export', filter);
	}

}

export default ExportToCSVRouteService;
